import React from 'react';
import styles from './FloTable.module.css';
import { Table } from 'react-bootstrap';
import { FloComponentProps } from 'components';
import classnames from 'classnames';
import FloTableRow from './FloTableRow';
import { FloColumnDef, FloTableActions, FloTableData } from './model';
import { useTranslation } from 'react-i18next';

export interface FloTableProps extends FloComponentProps {
  columns:        FloColumnDef[];
  data:           FloTableData;
  actions?:       FloTableActions;
  scrollable?:    boolean;
  height?:        number;
  customWidths?:  boolean;
}

export const FloTable: React.FC<FloTableProps> = ({
  className,
  columns,
  data,
  actions,
  scrollable = false,
  height,
  customWidths = false,
}) => {
  const { t } = useTranslation('flo-components');
  const rowKeys: string[] = columns.filter(col => col.isKey).map(col => col.id);
  const rowKey = rowKeys.join('::');

  const tbodyStyle = height ? { height } : {};
  const tdStyle = (column: FloColumnDef) => column.width ? {
    width: column.width
  } : {}

  return (
    <div
      className={classnames(
        styles.root,
        className,
        { [styles.customWidths]: customWidths }
      )}
    >
      <Table className={styles.table}>
        <thead>
          <tr>
            { columns.filter(col => !col.isHidden).map(col => (<td key={`flo-header-col-${col.id}`} style={tdStyle(col)} className={styles.headerTd}>{col.title}</td>)) }
            { actions && <td key={`flo-header-col-actions`} className={styles.headerTd} >{t('Actions')}</td> }
          </tr>
        </thead>
        <tbody
          className={classnames(
            { [styles.scrollable]: scrollable }
          )}
          style = {tbodyStyle}
        >
          {
            data.map(row => {
              const keyValues = rowKeys.map(key => row[key])
              return <FloTableRow
                key           = {keyValues.join('-')}
                rowKey        = {rowKey}
                values        = {row}
                columns       = {columns}
                actions       = {actions}
                customWidths  = {customWidths}
              />
            })
          }
        </tbody>
      </Table>
    </div>
  );
};

export default FloTable;
